import script from "./TagInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagInput.vue?vue&type=script&setup=true&lang=ts"

import "./TagInput.vue?vue&type=style&index=0&id=385a52a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-385a52a9"]])

export default __exports__